import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { VrrButton, VrrTable } from '../../../shared_components';
import { FILTERS, getTotalByFilter, prepareBody } from './services';
import { TCampaign, TCampaignFilters } from './types';
import { TCampaignVideo } from '../types';
import './Campaign.scss';

const Campaign: React.FC<TCampaign> = ({ campaigns }) => {
  const { t } = useTranslation();
  const [lines, setLines] = useState<TCampaignVideo[] | undefined>(undefined);
  const [filters, setFilters] = useState<TCampaignFilters[]>(FILTERS);

  useEffect(() => {
    setLines(campaigns);
  }, [campaigns]);
  const onChange = (buttonId: string) => {
    const newButtons = filters.map((button) => {
      return {
        id: button.id,
        label: button.label,
        isActive: button.id === buttonId
      };
    });
    const newLines =
      buttonId === 'all'
        ? campaigns
        : campaigns?.filter((campaign) => campaign.type === buttonId);
    setFilters(newButtons);
    setLines(newLines);
  };

  return (
    <div className="import-data-modal-campaign-container">
      <div className="campaign-filters">
        {filters.map((button) => (
          <>
            <VrrButton
              className={`btn-link campaign-filter ${button.isActive ? 'is-active' : ''}`}
              onClick={() => onChange(button.id)}
              children={t(button.label)}
            />
            <p className={`filter-total ${button.isActive ? 'is-active' : ''}`}>
              {getTotalByFilter(button.id, campaigns)}
            </p>
          </>
        ))}
      </div>
      <VrrTable
        header={[]}
        body={prepareBody(lines)}
        tableProps={{
          className: 'campaign-table'
        }}
      />
    </div>
  );
};

export default Campaign;
